import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PopularAppsComponent} from './popular-apps.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {NgbDropdownModule, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {NavModule} from 'ng-design-system';
import {ProductTileModule} from '../../shared/product-tile/product-tile.module';


@NgModule({
  declarations: [PopularAppsComponent],
  exports: [
    PopularAppsComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    MediaModule,
    ProductTileModule,
    NgbDropdownModule,
    NgbNavModule,
    ConfigModule.withConfig({
      cmsComponents: {
        PrioritizedCategoryFlexComponent: {
          component: PopularAppsComponent
        }
      }
    }),
    NavModule,
  ]
})
export class PopularAppsModule {
}

